import React from "react";
import classNames from "classnames";

const ViewModeSwitcher = ({ viewMode, onViewModeChange }) => (
  <div className="view-mode-switcher__app">
    <span className="view-mode-switcher__label">Visning</span>
    <a
      className={classNames(
        "btn btn-default view-mode-switcher__switch view-mode-switcher__switch--grid",
        {
          disabled: viewMode == "grid"
        }
      )}
      onClick={() => onViewModeChange("grid")}
    >
      <i className="fa fa-th" />
    </a>
    <a
      className={classNames(
        "btn btn-default view-mode-switcher__switch view-mode-switcher__switch--list",
        {
          disabled: viewMode == "list"
        }
      )}
      onClick={() => onViewModeChange("list")}
    >
      <i className="fa fa-list" />
    </a>
  </div>
);

export default ViewModeSwitcher;
